export const profile = {
  name: "Even Torbjørnsen",
  title: {
    NO: "Økonomi- og teknologikandidat · Sivilingeniør",
    EN: "Economics & technology graduate · Engineer",
  },
  location: "Lofoten / Bergen, Norge",
  company: "Explizit AS",
  orgNr: "927 609 924",
  email: "even@explizit.no",
  linkedin: "https://www.linkedin.com/in/eventorb",
  birthDate: "1997-09-11",

  intro: {
    NO: "Nyutdannet kandidat med tverrfaglig bakgrunn i økonomi og datateknologi. Jeg trives i skjæringspunktet mellom data, økonomi, digitalisering og problemløsning — og tar oppdrag innen analyse, data og teknologiske løsninger.",
    EN: "Newly graduated with a cross-disciplinary background in finance and engineering. I work at the intersection of data, finance and digitalization — available for consulting in analytics, data and applied software.",
  },

  skills: {
    NO: [
      "Python",
      "SQL",
      "Java",
      "Dataanalyse",
      "Git/GitHub",
      "Maskinlæring / ML/DL",
      "AI Agenter",
      "AI/LLM-verktøy",
      "REST API",
      "CI/CD",
      "Linux",
      "Docker",
      "Excel",
      "Databaser",
      "Tidsserieanalyse",
      "Økonomisk analyse",
      "Forretningsforståelse",
      "Problemløsning",
      "AI-assistert utvikling",
    ],
    EN: [
      "Python",
      "SQL",
      "Java",
      "Data analysis",
      "Git/GitHub",
      "Machine learning / ML/DL",
      "AI agents",
      "AI/LLM tools",
      "REST API",
      "CI/CD",
      "Linux",
      "Docker",
      "Excel",
      "Databases",
      "Time series analysis",
      "Financial analysis",
      "Business understanding",
      "Problem solving",
      "AI-assisted development",
    ],
  },

  education: {
    NO: [
      { degree: "Master", field: "Anvendt datateknologi / sivilingeniør", school: "HVL" },
      { degree: "Bachelor", field: "Dataingeniørfag", school: "HVL" },
      { degree: "Bachelor", field: "Økonomi og administrasjon", school: "UiT" },
    ],
    EN: [
      { degree: "Master's", field: "Applied computer science / engineering", school: "HVL" },
      { degree: "Bachelor's", field: "Computer engineering", school: "HVL" },
      { degree: "Bachelor's", field: "Business administration", school: "UiT" },
    ],
  },

  interests: {
    NO: [
      "Fotball — Liverpool, Tromsø og Norge",
      "Frisbeegolf",
      "Gaming",
      "Trening og turer",
      "Musikk",
      "Utviklingsprosjekter",
    ],
    EN: [
      "Football — Liverpool, Tromsø and Norway",
      "Disc golf",
      "Gaming",
      "Training and hiking",
      "Music",
      "Development projects",
    ],
  },

  about: {
    NO: [
      "Hei! Jeg heter Even Torbjørnsen, er {{age}} år, og kommer opprinnelig fra Tromsø. De første årene av livet bodde jeg der før familien flyttet videre til Svolvær for en kort periode. Da jeg var fem år gammel flyttet vi til Fredvang i Lofoten, som siden har vært stedet jeg kaller hjem.",
      "Gjennom oppveksten utviklet jeg en stor lidenskap for fotball. Utallige timer ble tilbrakt på banen, og interessen fulgte meg gjennom skolegangen ved Ramberg barne- og ungdomsskole og senere til idrettsfag på videregående i Leknes, hvor jeg satset på toppidrett fotball. Fotballen lærte meg mye om lagarbeid, disiplin og viktigheten av å jobbe målrettet over tid – erfaringer jeg fortsatt tar med meg i alt jeg gjør.",
      "Etter videregående gjennomførte jeg førstegangstjenesten i 2017. Året etter tok jeg et friår hvor jeg jobbet, spilte fotball og brukte tid på å finne ut hvilken retning jeg ønsket å gå videre i livet. Våren 2019 startet jeg på forkurs ved NTNU med matematikk og fysikk. Da jeg ikke bestod matematikk på første forsøk, måtte planene settes på vent. Selv om det var en skuffelse der og da, ble det også en viktig erfaring. Jeg ga ikke opp, tok faget på nytt og bestod året etter.",
      "I 2020 startet jeg på bachelor i dataingeniør ved Høgskulen på Vestlandet. Underveis oppdaget jeg at interessen min ikke bare handlet om teknologi, men også om hvordan teknologi kan brukes til å skape verdi og ta bedre beslutninger. Derfor begynte jeg parallelt på bachelor i økonomi og administrasjon ved UiT i 2022, samtidig som jeg fortsatte studiene innen teknologi. Etter fullført bachelor fortsatte jeg med master ved Høgskulen på Vestlandet, og fullførte totalt tre grader i løpet av få år.",
      "Etter studiene valgte jeg å ta et friår i 2025–2026. Denne perioden har jeg brukt til å jobbe deltid, utvikle egne prosjekter og bygge videre på Aura AS. For meg har dette vært en verdifull mulighet til å omsette kunnskap til praksis, utforske nye idéer og utvikle meg både faglig og personlig.",
      "Som person er jeg nysgjerrig og løsningsorientert. Jeg liker å forstå hvordan ting fungerer, enten det handler om teknologi, mennesker eller samspillet mellom dem. Jeg trives med å lære nye ting, analysere utfordringer og finne gode løsninger, og jeg motiveres av kontinuerlig utvikling.",
      "På fritiden følger jeg Liverpool, Tromsø og det norske landslaget med stor interesse. Jeg liker også å spille frisbeegolf, trene, gå turer, game og høre på musikk. Jeg setter pris på gode samtaler, møter gjerne nye mennesker og tror at vi lærer mest når vi er åpne for ulike perspektiver.",
    ],
    EN: [
      "Hi! I'm Even Torbjørnsen, I'm {{age}} years old, and I'm originally from Tromsø. I spent my early years there before my family moved to Svolvær for a short period. When I was five, we moved to Fredvang in Lofoten — the place I've called home ever since.",
      "Growing up, I developed a strong passion for football. Countless hours on the pitch followed me through school at Ramberg primary and lower secondary, and later to the sports programme at upper secondary in Leknes, where I pursued elite football. Football taught me a lot about teamwork, discipline, and working purposefully over time — lessons I still carry with me.",
      "After upper secondary, I completed my military service in 2017. The following year I took a gap year — working, playing football, and figuring out which direction to take next. In spring 2019 I started a preparatory course at NTNU in mathematics and physics. When I didn't pass maths on the first attempt, my plans had to wait. It was disappointing at the time, but also an important experience. I didn't give up, retook the course, and passed the year after.",
      "In 2020 I started a bachelor's in computer engineering at Western Norway University of Applied Sciences. Along the way I realised my interest wasn't only technology, but how technology creates value and supports better decisions. So in 2022 I began a parallel bachelor's in business administration at UiT while continuing my technology studies. After completing my bachelor's, I continued with a master's at HVL — three degrees in just a few years.",
      "After my studies I chose a gap year in 2025–2026. I've spent this time working part-time, developing my own projects, and building on Aura AS. For me it's been a valuable chance to turn knowledge into practice, explore new ideas, and grow both professionally and personally.",
      "As a person I'm curious and solution-oriented. I like understanding how things work — whether technology, people, or the interplay between them. I enjoy learning, analysing challenges, finding good solutions, and I'm motivated by continuous development.",
      "In my free time I follow Liverpool, Tromsø, and the Norwegian national team with great interest. I also enjoy disc golf, training, hiking, gaming, and music. I value good conversations, enjoy meeting new people, and believe we learn most when we're open to different perspectives.",
    ],
  },
};
